<div *ngIf="!showRequest">
  <h2 *ngIf="isShow" class="sectionTitle">{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.FORM_TITLE' | translate }}</h2>

  <div *ngIf="baseRequestId" class="read-only-content">
    <!-- request Details summary -->
    <app-transit-request [IsAdminMode]="true"></app-transit-request>
  </div>

  <div *ngIf="baseRequestId">
    <!-- Tab Buttons -->
    <div class="CSACustomTabs">
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" [class.active]="activeTugBoatType === tugType.EscortTug"><a href="#tab_1"
            (click)="switchTugBoatType(tugType.EscortTug)" aria-controls="home" role="tab" data-toggle="tab">
            {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.ESCORT_TUGS_SECTION' | translate}}
          </a></li>
        <li role="presentation" [class.active]="activeTugBoatType === tugType.ImposedTug"><a href="#tab_2"
            (click)="switchTugBoatType(tugType.ImposedTug)" aria-controls="home" role="tab" data-toggle="tab">
            {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.IMPOSED_TUGS_SECTION' | translate}}
          </a></li>
      </ul>
    </div>

    <form [formGroup]="imposeTugBoatsForm" #ImposeTugBoats>
      <div class="form-container"
        style="border: 1px solid #ddd; margin: 10px; padding: 10px; border-radius: 5px; overflow-x: auto !important;">
        <!-- Escorting Tugs Section -->
        <div *ngIf="activeTugBoatType === tugType.EscortTug" class="form-section" id="tab_1">
          <h4 class="section-title">{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.ESCORT_TUGS_SECTION'| translate}}</h4>
          <div *ngIf="!imposeTugBoatsForm.disabled" class="tab-container">
            <div class="tab-pane">
              <p class="btns-holder">
                <button type="button" class="btn SCAcustomBtn" Confirmation
                  (confirmationClick)="addEscortTugRule()">(+){{'FRONT_USER.ADD' | translate }}</button>
              </p>
            </div>
          </div>
          <div class="table-responsive">
            <table formArrayName="escortTugs" class="table table-bordered table-striped table-services"
              style="min-width: 1250px; max-width: none; table-layout: fixed;">
              <thead>
                <tr>
                  <th style="width: 90px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.NUMBER_OF_TUGS' | translate}}
                    </span></th>
                  <th style="width: 220px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.REASON' | translate}}
                    </span></th>
                  <th style="width: 220px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.NOTE' | translate}}
                    </span></th>
                  <th style="width: 180px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.IMPOSEDBY' | translate}}
                    </span></th>
                  <th style="width: 180px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.APPROVEDBY' | translate}}
                    </span></th>
                  <th *ngIf="!imposeTugBoatsForm.disabled" style="width: 160px;">
                    <span>{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.ACTION' |
                      translate}}</span>
                  </th>
                  <th *ngIf="!imposeTugBoatsForm.disabled && hasAnyEscortTugRejected()" style="width: 200px;">
                    <span>{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.REJECTION_REASON' | translate}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tug of f.escortTugs['controls']; let i = index" [formGroupName]="i">
                  <td style="width: 90px;">
                    <input type="number" class="form-control" formControlName="TugsNo" min="1" />
                    <div *ngIf="submitted || (tug.get('TugsNo')?.dirty && tug.get('TugsNo')?.errors)" class="red">
                      <div *ngIf="tug.get('TugsNo')?.errors?.required">
                        {{'FRONT_USER.This_Field_Is_Required' | translate}}
                      </div>
                    </div>
                  </td>
                  <td style="width: 220px;"><textarea type="text" class="form-control"
                      formControlName="Reason"></textarea>
                  </td>
                  <td style="width: 220px;"><textarea type="text" class="form-control"
                      formControlName="Note"></textarea>
                  </td>
                  <td style="width: 180px;">
                    <label>{{tug.get('ImposedBy')?.value}}</label>
                  </td>
                  <td style="width: 180px;">
                    <label>{{tug.get('ApprovedBy')?.value}}</label>
                  </td>
                  <td *ngIf="!imposeTugBoatsForm.disabled" style="text-align: center;">
                    <!-- Approve/Reject action for escort tugs loaded from DB -->
                    <div *ngIf="tug.get('Id')?.value != null" class="form-group">
                      <div class="custom-Radio">
                        <input [id]="'chkApprove' + i" type="radio" [attr.name]="'IsApproved_' + i" [value]="true"
                          formControlName="IsApproved" (change)="OnApprovalDecisionChange($event, i, 'escortTugs')" />
                        <label [for]="'chkApprove' + i">{{'FRONT_USER.ADMIN_DECISION_FORM.Approve' | translate}}</label>
                      </div>
                      <div class="custom-Radio">
                        <input [id]="'chkReject' + i" type="radio" [attr.name]="'IsApproved_' + i" [value]="false"
                          formControlName="IsApproved" (change)="OnApprovalDecisionChange($event, i, 'escortTugs')" />
                        <label [for]="'chkReject' + i">{{'FRONT_USER.ADMIN_DECISION_FORM.Reject' | translate}}</label>
                      </div>
                    </div>
                    <!-- Delete action for escort tugs newly added via button -->
                    <a *ngIf="tug.get('Id')?.value == null" Confirmation (confirmationClick)="deleteEscortTugRule(i)"
                      title="{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.DELETE_TUG_RULE' | translate}}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <circle cx="16" cy="16" r="16" fill="#E53935" />
                        <path fill="#FFFFFF"
                          d="M21.656 10.344a1.2 1.2 0 0 0-1.697 0L16 14.303l-3.959-3.959a1.2 1.2 0 1 0-1.697 1.697L14.303 16l-3.959 3.959a1.2 1.2 0 1 0 1.697 1.697L16 17.697l3.959 3.959a1.2 1.2 0 0 0 1.697-1.697L17.697 16l3.959-3.959a1.2 1.2 0 0 0 0-1.697z" />
                      </svg>
                    </a>
                  </td>
                  <td *ngIf="!imposeTugBoatsForm.disabled && hasAnyEscortTugRejected()">
                    <ng-container *ngIf="tug.get('Id')?.value != null && tug.get('IsApproved')?.value === false">
                      <textarea class="form-control" formControlName="RejectionReason"
                        placeholder="{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.REJECTION_REASON' | translate}}"></textarea>
                      <div *ngIf="submitted || (tug.get('RejectionReason')?.dirty && tug.get('RejectionReason')?.errors)" class="red">
                        <div *ngIf="tug.get('RejectionReason')?.errors?.required">
                          {{'FRONT_USER.This_Field_Is_Required' | translate}}
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Imposed Tugs Section -->
        <div *ngIf="activeTugBoatType === tugType.ImposedTug" class="form-section" id="tab_2">
          <h4 class="section-title">{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.IMPOSED_TUGS_SECTION'| translate}}</h4>
          <div *ngIf="!imposeTugBoatsForm.disabled" class="tab-container">
            <div class="tab-pane">
              <p class="btns-holder">
                <button type="button" class="btn SCAcustomBtn" Confirmation
                  (confirmationClick)="addImposedTugRule()">(+){{'FRONT_USER.ADD' | translate }}</button>
              </p>
            </div>
          </div>
          <div class="table-responsive">
            <table formArrayName="imposedTugs" class="table table-bordered table-striped table-services"
              style="min-width: 1350px; max-width: none; table-layout: fixed;">
              <thead>
                <tr>
                  <th style="width: 90px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.NUMBER_OF_TUGS' | translate}}
                    </span></th>
                  <th style="width: 180px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.REASON' | translate}}
                    </span></th>
                  <th style="width: 180px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.NOTE' | translate}}
                    </span></th>
                  <th style="width: 160px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.TUG_CATEGORY' | translate}}
                    </span></th>
                  <th style="width: 180px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.IMPOSEDBY' | translate}}
                    </span></th>
                  <th style="width: 180px;"><span>
                      {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.APPROVEDBY' | translate}}
                    </span></th>
                  <th *ngIf="!imposeTugBoatsForm.disabled" style="width: 160px;">
                    <span>{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.ACTION' |
                      translate}}</span>
                  </th>
                  <th *ngIf="!imposeTugBoatsForm.disabled && hasAnyImposedTugRejected()" style="width: 200px;">
                    <span>{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.REJECTION_REASON' | translate}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tug of f.imposedTugs['controls']; let i = index" [formGroupName]="i">
                  <td>
                    <input type="number" class="form-control" formControlName="TugsNo" min="1" />
                    <div *ngIf="submitted || (tug.get('TugsNo')?.dirty && tug.get('TugsNo')?.errors)" class="red">
                      <div *ngIf="tug.get('TugsNo')?.errors?.required">
                        {{'FRONT_USER.This_Field_Is_Required' | translate}}
                      </div>
                    </div>
                  </td>
                  <td class="col-xs-4"><textarea type="text" class="form-control" formControlName="Reason"></textarea>
                  </td>
                  <td class="col-xs-4"><textarea type="text" class="form-control" formControlName="Note"></textarea>
                  </td>
                  <td>
                    <select formControlName="TugCategory" class="form-control">
                      <option [value]='null' selected>
                        {{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.CHOOSE_TUG_CATEGORY' | translate}}
                      </option>
                      <ng-container *ngFor="let tugCategoryKey of tugCategoryKeys">
                        <option [value]="tugCategory[tugCategoryKey]">
                          {{ 'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.' + tugCategoryKey | translate }}
                        </option>
                      </ng-container>
                    </select>
                    <div *ngIf="submitted || (tug.get('TugCategory')?.dirty && tug.get('TugCategory')?.errors)"
                      class="red">
                      <div *ngIf="tug.get('TugCategory')?.errors?.required">
                        {{'FRONT_USER.This_Field_Is_Required' | translate}}
                      </div>
                    </div>
                  </td>
                  <td style="width: 180px;"><label>{{tug.get('ImposedBy')?.value}}</label></td>
                  <td style="width: 180px;"><label>{{tug.get('ApprovedBy')?.value}}</label></td>
                  <td *ngIf="!imposeTugBoatsForm.disabled" style="text-align: center;">
                    <!-- Approve/Reject action for imposed tugs loaded from DB -->
                    <div *ngIf="tug.get('Id')?.value != null" class="form-group">
                      <div class="custom-Radio">
                        <input [id]="'chkImpApprove' + i" type="radio" [attr.name]="'imp_IsApproved_' + i"
                          [value]="true" formControlName="IsApproved"
                          (change)="OnApprovalDecisionChange($event, i, 'imposedTugs')" />
                        <label [for]="'chkImpApprove' + i">{{'FRONT_USER.ADMIN_DECISION_FORM.Approve' |
                          translate}}</label>
                      </div>
                      <div class="custom-Radio">
                        <input [id]="'chkImpReject' + i" type="radio" [attr.name]="'imp_IsApproved_' + i"
                          [value]="false" formControlName="IsApproved"
                          (change)="OnApprovalDecisionChange($event, i, 'imposedTugs')" />
                        <label [for]="'chkImpReject' + i">{{'FRONT_USER.ADMIN_DECISION_FORM.Reject' |
                          translate}}</label>
                      </div>
                    </div>
                    <!-- Delete action for imposed tugs newly added via button -->
                    <a *ngIf="tug.get('Id')?.value == null" Confirmation (confirmationClick)="deleteImposedTugRule(i)"
                      title="{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.DELETE_TUG_RULE' | translate}}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <circle cx="16" cy="16" r="16" fill="#E53935" />
                        <path fill="#FFFFFF"
                          d="M21.656 10.344a1.2 1.2 0 0 0-1.697 0L16 14.303l-3.959-3.959a1.2 1.2 0 1 0-1.697 1.697L14.303 16l-3.959 3.959a1.2 1.2 0 1 0 1.697 1.697L16 17.697l3.959 3.959a1.2 1.2 0 0 0 1.697-1.697L17.697 16l3.959-3.959a1.2 1.2 0 0 0 0-1.697z" />
                      </svg>
                    </a>
                  </td>
                  <td *ngIf="!imposeTugBoatsForm.disabled && hasAnyImposedTugRejected()">
                    <ng-container *ngIf="tug.get('Id')?.value != null && tug.get('IsApproved')?.value === false">
                      <textarea class="form-control" formControlName="RejectionReason"
                        placeholder="{{'ADMIN_USER.TRANSIT.IMPOSE_TUG_BOATS.REJECTION_REASON' | translate}}"></textarea>
                      <div *ngIf="submitted || (tug.get('RejectionReason')?.dirty && tug.get('RejectionReason')?.errors)" class="red">
                        <div *ngIf="tug.get('RejectionReason')?.errors?.required">
                          {{'FRONT_USER.This_Field_Is_Required' | translate}}
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
      <!-- Single Submit Button -->
      <div *ngIf="formMode == FormMode.Add && shouldShowSubmitButton()" class="form-group">
        <button Confirmation (confirmationClick)="onSubmit()" class="btn SCAcustomBtn">{{
          'FRONT_USER.SUBMIT' | translate}}</button>
      </div>
    </form>
  </div>
</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingReport">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_REPORT' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingReport">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_REPORT' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingReport">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_REPORT' | translate }}</a></p>
  </div>
</div>